export const PHOTO_ID_METADATA = {
  exampleImageAlt: 'Graphic of a photo ID',
  exampleImageUrl:
    'https://images.ctfassets.net/8pzh4g8cs30t/1WGQGVYdq0ilKlMcOSQNSf/d0c08a599869c5d262d33ce24209beaf/photo_id_upload_example_image.jpg',
  imagesHeight: 96,
  imagesWidth: 125,
  isForProvider: true,
  isIdVerification: true,
  modalLinkText: 'What kind of ID can I use?',
  title: 'Photo ID',
  type: 'photo-id',
  uploadImageText: 'Add a photo',
};
